import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=6802f5e1&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=js&"
export * from "./DropZone.vue?vue&type=script&lang=js&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=6802f5e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6802f5e1",
  null
  
)

export default component.exports